import TableContainer from "@material-ui/core/TableContainer";
//import Table from "@material-ui/core/Table";
import {Typography, Box, ListItemText} from "@material-ui/core";
import {Table, AutoSizer, MultiGrid, ColumnSizer, Grid, CellMeasurer, CellMeasurerCache} from "react-virtualized";
import React, {useMemo} from "react";
import _ from "lodash";

import SensorReportData from "./SensorReportData";


const SensorReportTable = ({data, classes}) => {
    const [isHomogeneous] = useMemo(() => {
        if(!data)
            return [null, null]
        let _headers = []
        _.each(data, (record) => {
            _headers = [..._headers, _.map(record.sensorReport, (report) => ({type: report.type, uom: report.uom}))]
        })
        const isHomo = _.every(_headers, function (o) {
            return JSON.stringify(o) === JSON.stringify(_headers[0])
        })
        return [isHomo]
    }, [data])


    return data.length ? isHomogeneous === false ? 
        <div>
            {        
                data.map((record, index)=> (<SensorReportData data={[record]} classes={classes}/>))
            }
        </div>
    
    :
       <SensorReportData data={data} classes={classes}/>
                    //<MultiGrid
                    //  className={classes.tableBorder}
                    //  deferredMeasurementCache={_cache}
                    //  columnWidth={_cache.columnWidth}
                    //  overscanColumnCount={0}
                    //  overscanRowCount={0}
                    //  fixedColumnCount={1}
                    //  fixedRowCount={1}
                    //  columnCount={data[0].sensorReport.length + 1}
                    //  enableFixedColumnScroll
                    //  enableFixedRowScroll
                    //  height={300}
                    //  rowHeight={70}
                    //  rowCount={data.length+1}
                    //  width={width}
                    //  hideTopRightGridScrollbar
                    //  hideBottomLeftGridScrollbar
                    //  cellRenderer={(props)=>renderGridCell({...props, data_index: -1})}/>
    : null

}

export default SensorReportTable
